<template>
  <div class="project">
    <v-layout column>
      <v-flex xs12 class="white">
        <v-card elevation="0" v-if="render === true" class="background" height="85vh">
          <v-card-text>
            <div>
              <v-map
                ref="myMapRef"
                style="
                  position: absolute;
                  width: 98%;
                  height: 80vh;
                  z-index: 2;
                "
                :zoom="-1"
                :center="[newLocation.latitude, newLocation.longitude]"
                :options="tileOptions"
              >
                <!-- <v-tilelayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                ></v-tilelayer> -->

                <v-tilelayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"></v-tilelayer>
               <!-- <v-tilelayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"></v-tilelayer> -->
                <v-marker-cluster :options="clusterOptions" v-for="(project, index) in projects" :key="index">
                  <v-marker
                    v-for="(country, idx) in project.countries"
                    :key="idx"
                    :lat-lng="[country.latitude, country.longitude]"
                    :icon="icon"
                    @click="locationDataBasic(location)"
                  >
                    <v-leaftooltip>
                      <div>
                        <b>{{ $t('projectMsg') }}:</b> {{ project.name }}<br />
                        <b>{{ $t('programmeMsg') }}:</b> {{ project.community.name }}<br />
                        <b>{{ $t('countryMsg') }}:</b> {{ country.name }}<br />
                      </div>
                    </v-leaftooltip>
                  </v-marker>
                </v-marker-cluster>
              </v-map>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- <v-flex xs12>
        Projects
      </v-flex>  -->
    </v-layout>
  </div>
</template>
<style>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

html,
body {
  height: 100%;
  margin: 0;
}
</style>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as Vue2Leaflet from 'vue2-leaflet'
import { latLng, Icon, icon } from 'leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet/dist/leaflet.css'
import iconUrl from '../../../../public/img/map/marker-icon.png'
import shadowUrl from '../../../../public/img/map/marker-shadow.png'
import iconRetinaUrl from '../../../../public/img/map/marker-icon-2x.png'
import Vue from "vue";
import { render } from "vue-clamp";

export default {
  components: {
    'v-map': Vue2Leaflet.LMap,
    'v-circle': Vue2Leaflet.LCircle,
    'v-tilelayer': Vue2Leaflet.LTileLayer,
    'v-icondefault': Vue2Leaflet.LIconDefault,
    'v-marker': Vue2Leaflet.LMarker,
    'v-popup': Vue2Leaflet.LPopup,
    'v-leaftooltip': Vue2Leaflet.LTooltip,
  },
  props: {
    itemObjects: {
      default: null,
    },
    render: {
      default: false,
    },
  },
  data() {
    let customicon = icon(Object.assign({},
      Icon.Default.prototype.options,
      { iconUrl, shadowUrl }
    ))
    return {
      icon: customicon,
      tileOptions: {
        minZoom: 3.4,
        minNativeZoom: 1,
        detectRetina: true,
        updateWhenIdle: false,
        keepBuffer: 10,
        language: 'en',
      },
      clusterOptions: {},
      newLocation: {
        longitude: '37.36322',
        latitude: '-0.44822'
      },
      projectLoader: false,
      images: "",
      projects: "",
      path: process.env.VUE_APP_API_URL,
      dialog: false,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,

      activeGallery: "launch",
      mediaGroup: "launch",
      assignedAlbum: "6",
      assignedImage: null,
      imageIndex: 0,
      arrayNumber: null,

      absolute: true,
      overlay: true,
      opacity: 0.3,
    };
  },
  watch: {
    itemObjects: {
      deep: true,
      handler(newVal) {
        this.projects = newVal;
      },
    },
    render: {
      deep: true,
      handler(newVal) {
        this.render = newVal;
      },
    },
  },

  mounted() {},
  created() {
    window.scrollTo(0, 0);
    console.log("<><><><><><><><><><><>><><><><><><><><><><><>");
    console.log(this.itemObjects);
    this.projects = this.itemObjects;
  },
  attrs() {},
  methods: {
    ...mapActions([]),
    switchTab(tab) {
      //this.$emit('currentTab', tab)
    },
    showStuff(project) {
      console.log(project.name);
    },
  },
  computed: {
    ...mapGetters(["darkState"]),
  },
};
</script>